document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  
  // Set first accordion to be expanded by default
  if (accordionHeaders.length > 0) {
    accordionHeaders[0].setAttribute('aria-expanded', 'true');
  }
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', !isExpanded);
      
      // Toggle the accordion content visibility
      const content = header.nextElementSibling;
      if (content && content.classList.contains('accordion-content')) {
        content.style.display = isExpanded ? 'none' : 'block';
      }
    });
    
    // Set initial content visibility based on aria-expanded
    const content = header.nextElementSibling;
    if (content && content.classList.contains('accordion-content')) {
      content.style.display = header.getAttribute('aria-expanded') === 'true' ? 'block' : 'none';
    }
  });
}); 